// import CustomerTab from '../../components/CustomerTab';
import CustomerHeader from '../../components/CustomerHeader';
import ManagerSidebar from '../../components/manager/ManagerSidebar';
import ServicesTab from '../../components/manager/ServicesTab';


const ServicesScreen = () => {
  return (
    <>
        <section className='dashboard-container flex '>
          <aside className=''>
              <ManagerSidebar />
          </aside>
          <main className='main-container mb-32'>
              <CustomerHeader orderTitle={'Services'} orderSubtitle={'Manage services'} showServicesButton={true}/>

            <section className='mt-20 flex gap-4'>
              <section>
                <ServicesTab/>
              </section>
            </section>
          </main>
        </section>
    </>
    
  )
}

export default ServicesScreen